import { useEffect, useState } from 'react';
import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { useCookieWallDisplayed } from '../hooks/useCookieWallDisplayed';

import { CookieWallContainer } from './CookieWall';

export const CookieWallWrapperContainer: React.FC<EmptyProps> = () => {
	const [alert, setAlert] = useState<'success' | 'error' | undefined>();
	const showCookieWall = useCookieWallDisplayed();

	useEffect(() => {
		if (!alert) return undefined;

		const timeout = window.setTimeout(() => setAlert(undefined), 10000);

		return () => {
			window.clearTimeout(timeout);
		};
	}, [alert]);

	return (
		<>
			{showCookieWall && (
				<CookieWallContainer
					onAccept={() => setAlert('success')}
					onReject={() => setAlert('success')}
					onError={() => setAlert('error')}
				/>
			)}
			{alert && (
				<div role="alert" className="sr-only">
					<TypedTranslate value={translationKey(`corgi.cookie_wall.${alert}`)} />
				</div>
			)}
		</>
	);
};
